export default {"src":"/_next/static/media/licenseWork.1db18029.svg","height":72,"width":61};